export default "__VITE_ASSET__C3kePn30__"